import { GlobalEnableMessaging } from './GlobalEnableMessaging.js'
import { GroupMessagingSettings } from './GroupMessagingSettings.js'
import { MembersEnableMessaging } from './MembersEnableMessaging.js'

export const Messaging = () => {
  return (
    <div className="max-w-3xl space-y-5">
      <GlobalEnableMessaging />
      <MembersEnableMessaging />
      <GroupMessagingSettings />
    </div>
  )
}
